import Styles from './TableMaker.scss';

import Template from './TableMaker.hbs';
import ToggleSwitch from 'views/components/toggleSwitch/ToggleSwitch.svelte';
import NumberInput from 'views/components/quickInput/numberInput/NumberInput.svelte'

export default class TableMaker extends BaseView {

    initialize() {

        // Default with border, 2 rows, 2 columns
        this.chosenOptions = {
            border: true,
            rows: [0, 1],
            cols: [0, 1],
        }

        this.setElement(Template({ Styles }))

        this.numberOfRowsInput = this.addSvelteChildView('.js-number-of-rows-input', NumberInput, {
            min: 1,
            max: 100,
            value: this.chosenOptions.rows.length
        })

        this.numberOfColumnsInput = this.addSvelteChildView('.js-number-of-cols-input', NumberInput, {
            min: 1,
            max: 20,
            value: this.chosenOptions.cols.length,
        })

        if (ACL.checkRole(ACL.roles.TEACHER)) {
            this.$('.js-border-label').text(window.i18n.gettext('Border'))
            this.addSvelteChildView('.js-border-toggle', ToggleSwitch, {
                isChecked: this.chosenOptions.border,
                callback: (state) => this.chosenOptions.border = state
            })
        }

    }

    getRange(n) {
        return Array.from(Array(
            Number.isSafeInteger(n) && n >= 1 ? n : 1
        ).keys())
    }

    getOptions() {
        this.chosenOptions.rows = this.getRange(parseInt(this.numberOfRowsInput.getValue(), 10))
        this.chosenOptions.cols = this.getRange(parseInt(this.numberOfColumnsInput.getValue(), 10))
        return this.chosenOptions;
    }
}
